import Vue from 'vue'

/**
 * API로 전달 받은 상점을 구성하기 위한 데이터를 저장한다.
 * @param {*} state
 * @param {*} initData
 */
const SET_INIT_DATA = (state, initData) => {
  state.initData = { ...state.initData, ...initData }
}
/**
 * API로 전달 받은 상점의 home에 노출할 데이터를 저장한다.
 * @param {*} state
 * @param {*} homeData
 */
const SET_HOME_DATA = (state, homeData) => {
  state.homeData = { ...state.homeData, ...homeData }

  Vue.set(state.control, 'collectionList', {})
  if (homeData.collectionList.length) {
    let limit = 10
    if (homeData.collectionList.length === 1) {
      limit = 20
    }
    homeData.collectionList.forEach((el, idx) => {
      Vue.set(state.control.collectionList, idx, {
        size: limit,
        limit: limit,
        length: el.collectionProductList.length,
        isMore: el.collectionProductList.length > limit
      })
    })
  }

  Vue.set(state.control, 'newList', {})
  if (homeData.newList.length) {
    Vue.set(state.control, 'newList', {
      size: 20,
      limit: 20,
      length: homeData.newList.length,
      isMore: homeData.newList.length > 20
    })
  }
}
/**
 * home 화면의 콜렉션별 추가 목록을 불러온다.
 * @param {*} state
 * @param {*} param1
 */
const GET_MORE_LIST = (state, { type, index }) => {
  let control = state.control[type]
  if (control) {
    if (typeof index != 'undefined') {
      control = control[index]
    }
    control.size += control.limit
    control.isMore = control.size < control.length
  }
}
/**
 * API 호출로 전달 받은 카테고리 제품 목록을 저장한다.
 * @param {*} param0
 * @param {Object} param1
 * @param {Number} param1.page - 페이지 번호
 * @param {Array} param1.productList - 제품 목록
 * @param {Boolean} param1.last - 마지막 페이지 여부
 */
const SET_CATEGORY = ({ category }, { page, productList, last }) => {
  category.page = page
  if (productList.length) {
    // 정상 응답
    category.productList.push(...productList)
    if (productList.length < category.pageSize) {
      category.last = true
    }
  } else {
    if (category.page === 0) {
      category.productList = productList
    }
    category.last = typeof last != 'undefined' ? last : true
  }
}
/**
 * API 호출로 전달 받은 태그 제품 목록을 저장한다.
 * @param {*} param0
 * @param {Object} param1
 * @param {Number} param1.page - 페이지 번호
 * @param {Array} param1.productList - 제품 목록
 * @param {Boolean} param1.last - 마지막 페이지 여부
 */
const SET_TAG = ({ tag }, { page, productList, last }) => {
  tag.page = page
  if (productList.length) {
    // 정상 응답
    tag.productList.push(...productList)
    if (productList.length < tag.pageSize) {
      tag.last = true
    }
  } else {
    if (tag.page === 0) {
      tag.productList = productList
    }
    tag.last = typeof last != 'undefined' ? last : true
  }
}

/**
 * API 호출 가능 여부를 설정한다. 해당 mutation은 카테고리와 home에서 사용한다.
 * @param {*} state
 * @param {Boolean} possible - 호출 가능 여부
 */
const SET_REQUEST_POSSIBLE = (state, possible) => {
  state.requestPossible = possible
}

export default {
  SET_INIT_DATA,
  SET_HOME_DATA,
  SET_CATEGORY,
  SET_TAG,
  SET_REQUEST_POSSIBLE,
  GET_MORE_LIST
}
